import { render } from "./VisionCard.vue?vue&type=template&id=c5a60116&scoped=true"
import script from "./VisionCard.vue?vue&type=script&lang=js"
export * from "./VisionCard.vue?vue&type=script&lang=js"

import "./VisionCard.vue?vue&type=style&index=0&id=c5a60116&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5a60116"]])

export default __exports__